import { useEffect, useState } from "react";
import {
  Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import PhotoInput from "../PhotoInput";
import { useLanguage } from "../../i18n/LanguageContext";

export default function AddVisitPhotosDialog({ visit, onClose, onSave }) {
  const { t } = useLanguage();
  const [photos, setPhotos] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setPhotos([]);
    setError("");
  }, [visit?._id]);

  if (!visit) return null;

  const existingCount = visit.photos?.length || 0;
  const remainingSlots = Math.max(0, 6 - existingCount);

  const handleSave = async () => {
    if (photos.length === 0) return setError(t("visitantes.errNoNewPhotos"));
    setSaving(true);
    setError("");
    try {
      await onSave(visit._id, photos);
    } catch (err) {
      setError(err.response?.data?.error || t("visitantes.errGeneric"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!visit} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {t("visitantes.addPhotosTitle")}
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography fontWeight={600} sx={{ mb: 2 }}>
          {visit.name}
        </Typography>

        {remainingSlots > 0 ? (
          <PhotoInput value={photos} onChange={setPhotos} max={remainingSlots} label={t("visitantes.photosLabel")} />
        ) : (
          <Alert severity="info" icon={false}>
            {t("visitantes.photosLimitReached")}
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button variant="contained" startIcon={<CheckIcon />} onClick={handleSave} disabled={saving || remainingSlots === 0}>
          {saving ? t("common.saving") : t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
